<template>
    <base-alert
        v-if="errors !== null && errors.length > 0"
        type="error"
    >
        <ul :class="[errors.length > 1 ? 'list-disc' : 'list-none']">
            <li
                v-for="(errorMessage, index) of errors"
                :key="index"
            >
                {{ errorMessage }}
            </li>
        </ul>
    </base-alert>
</template>

<script>
import BaseAlert from './Base/BaseAlert'

export default {
  name: 'AlertValidationErrors',
  props: {
    errors: {
      type: Array,
      required: true
    }
  },
  components: { BaseAlert }
}
</script>
